// @flow
import type {Element} from 'react'
import React from 'react'

import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import ListItem from 'components/proposals/Part/ui/Summary/ListItem'
import styles from '../index.scss'

type Props = $ReadOnly<{
  section: any,
}>

const listItemTypeMap = {
  moving_in: 'movingIn',
  moving_out: 'movingOut',
}

function MinorList({section}: Props): Element<"div"> {
  const listItemType = listItemTypeMap[section.direction]

  return (
    <div className={styles.minorList}>
      <ChangeTitle title={section.title} />
      {section.entries.map((entry) => (
        <div key={entry} className={styles.minorListItem}>
          <ListItem type={listItemType}>
            {entry}
          </ListItem>
        </div>
      ))}
    </div>
  )
}

export default MinorList
